import styled from 'styled-components';

export const MainWrap = styled.div`
  &.path-lock-panel-wrap {
    position: absolute;
    bottom: 50px;
    width: 100%;
    position: absolute;
    z-index: 2;
    align-items: center;
    justify-content: center;
    display: flex;
    flex-direction: column-reverse;
    height: auto;
    z-index: 31;
    pointer-events: none;

    &.regular.mobile {
      z-index: 16;
      align-items: end;

      .path-lock-panel {
        border-radius: 50px;
        max-width: 90vw;
      }
    }

    .bt-audio-subs {
      position: initial;
      margin-bottom: 5px;
      bottom: initial;
    }
  }

  .path-lock-panel {
    background: rgba(255, 255, 255, 0.75);
    box-shadow: 0px 5px 6px -3px rgba(0, 0, 0, 0.25);
    backdrop-filter: blur(7.5px);

    border-radius: 35px;
    pointer-events: all;
    animation: 1s ease 0s 1 normal forwards running alert-toast-appear;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 5px;
    height: 60px;
    border-radius: 50px;
    font-size: 17px;
    line-height: 20px;
    letter-spacing: -0.02em;
    z-index: 1;
    width: 800px;
    max-width: 100%;

    .avatar {
      object-fit: cover;
      border-radius: 50%;
      width: auto;
      height: 50px;
    }

    .prev-btn {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      height: 50px;
      width: 70px;
      border-radius: 50%;
      font-weight: bold;

      font-size: 17px;
      line-height: 20px;
      letter-spacing: -0.02em;
      cursor: pointer;

      background: transparent;
      width: 55px;
      height: 41px;
      padding: 8px 15px 8px 16px;
      border-radius: 34px;
      margin-left: 11px;

      &:hover {
        box-shadow: inset 0px 0px 100px 0 #0000001c;
      }

      i {
        font-size: 20px;
      }
    }
    .path-lock-description + .prev-btn {
      margin-right: 11px;
    }
    .next-btn {
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 26px;
      align-items: center;
      text-align: center;
      letter-spacing: 0.46px;
      color: #ffffff;

      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      height: 50px;
      max-width: 150px;
      min-width: 100px;
      background: var(--color-secondary);
      border-radius: 50px;
      font-weight: bold;
      font-size: 17px;

      line-height: 20px;
      letter-spacing: -0.02em;
      cursor: pointer;

      &:hover {
        box-shadow: inset 0px 0px 100px 0 #0000001c;
      }

      span {
        margin-right: 13px;
        align-items: center;
        display: flex;
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 26px;
        text-transform: uppercase;
      }

      i {
        font-size: 20px;
      }
    }

    .path-lock-description {
      width: 100%;
      padding: 0 10px;
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 105%;
      align-items: center;
      letter-spacing: 0.15px;
      color: #333333;
    }
    @media screen and (orientation: portrait) {
      &.mobile {
        height: auto;
        .prev-btn,
        .next-btn {
          height: 30px;
          width: 35px;
          min-width: 35px;
          min-height: initial;
        }
      }
    }
  }

  @keyframes alert-toast-appear {
    from {
      transform: translate(0px, 100px);
      opacity: 0;
    }

    to {
      transform: translate(0px, 0px);
      opacity: 1;
    }
  }
`;
